import type { TFunction } from 'i18next';

/**
 * A translation that is a list of strings (`returnObjects: true`), checked
 * rather than asserted: a key that is missing or not a list yields `[]`.
 */
export function tList(t: TFunction, key: string): string[] {
  const value: unknown = t(key, { returnObjects: true });
  return Array.isArray(value)
    ? value.filter((item): item is string => typeof item === 'string')
    : [];
}
